import React from "react"
import { SeededRandom, reverseNumber } from "@jsUtils"

const CANVAS_SIZE = 560
const DOT_COUNT = 80

let drawTimeout = null

/**
 * Feature Graphic
 * @param {object} props - React props
 */
const PillarGraphic = props => {
  const { theme, color, format, className } = props
  const [isSetup, setIsSetup] = React.useState(false)
  const [dots, setDots] = React.useState([])
  let canvasRef = null
  let ctx = null
  let dpr = 2
  let frame = 0

  const setupDots = () => {
    for (let i = 0; i < DOT_COUNT; i++) {
      dots[i] = {
        pos: { x: CANVAS_SIZE * 0.5, y: CANVAS_SIZE * 0.5 },
        target: { x: CANVAS_SIZE * 0.5, y: CANVAS_SIZE * 0.5 },
        size: 0,
        targetSize: 0,
        opacity: 0,
        targetOpacity: 0,
        colored: false
      }
    }
  }

  const getPositionInRing = (current, total, radius, ratio) => {
    const ovalRatio = ratio === undefined ? 1 : ratio
    const pos = { x: null, y: null }
    pos.x = CANVAS_SIZE * 0.5 + radius * Math.cos((2 * Math.PI * current) / total)
    pos.y = CANVAS_SIZE * 0.5 + ovalRatio * radius * Math.sin((2 * Math.PI * current) / total)
    return pos
  }

  const updateDot = (index, RNG) => {
    const dot = dots[index]
    dot.colored = false
    dot.targetOpacity = 1
    dot.target = { x: CANVAS_SIZE * 0.5, y: CANVAS_SIZE * 0.5 }
    if (format === 0) {
      if (index === 0) {
        dot.targetSize = 14
        dot.colored = true
      } else if (index < 19) {
        dot.target = getPositionInRing(1 + index + (frame % 7500) * 0.0075, 18, CANVAS_SIZE * 0.45)
        dot.targetSize = 14
      } else if (index < 28) {
        dot.target = getPositionInRing(19 + index - (frame % 5000) * 0.005, 9, CANVAS_SIZE * 0.3)
        dot.targetSize = 10
      } else if (index < 32) {
        dot.target = getPositionInRing(28 + index + (frame % 3000) * 0.003, 4, CANVAS_SIZE * 0.15)
        dot.targetSize = 5
      } else {
        dot.targetSize = 0
        dot.targetOpacity = 0
      }
    } else if (format === 1) {
      if (index === 0) {
        dot.targetSize = 7
        dot.colored = true
      } else if (index === 1) {
        dot.target = getPositionInRing(
          (frame % 7500) * 0.0075,
          2,
          CANVAS_SIZE * 0.35 - Math.abs((frame % 500) - 250) * 0.25
        )
        dot.targetSize = 10
      } else if (index === 10) {
        dot.target = getPositionInRing(
          1 + (frame % 7500) * 0.0075,
          2,
          CANVAS_SIZE * 0.35 - Math.abs((frame % 500) - 250) * 0.25
        )
        dot.targetSize = 10
      } else {
        dot.targetSize = 0
        dot.targetOpacity = 0
      }
    } else if (format === 2) {
      if (index < 32) {
        dot.targetSize = Math.round(RNG.random(4, 14))
        dot.colored = Math.round(RNG.random(0, 0.6))
        if (dot.colored) {
          dot.targetOpacity = 1
        } else {
          dot.targetOpacity = RNG.random(0.4, 1.5)
        }
        const movementRate = `${Math.round(RNG.random(7200, 7500))}.0`
        dot.target = getPositionInRing(
          index + ((frame % movementRate) * reverseNumber(movementRate)) / 10,
          Math.round(RNG.random(3, 24)),
          CANVAS_SIZE * RNG.random(0.05, 0.4)
        )
      } else {
        dot.targetSize = 0
        dot.targetOpacity = 0
      }
    } else if (format === 3) {
      dot.targetSize = 5
      if (index < 10) {
        dot.target = getPositionInRing(index - (frame % 5000) * 0.005, 10, CANVAS_SIZE * 0.2, 0.45)
        dot.targetOpacity = 1 - (CANVAS_SIZE * 0.5 - dot.target.y) / (CANVAS_SIZE * 0.2 * 0.45)
        dot.target.y += -135
      } else if (index < 26) {
        dot.target = getPositionInRing(
          16 + index - (frame % 5000) * 0.005,
          16,
          CANVAS_SIZE * 0.34,
          0.45
        )
        dot.targetOpacity = 1 - (CANVAS_SIZE * 0.5 - dot.target.y) / (CANVAS_SIZE * 0.34 * 0.45)
        dot.target.y += -75
      } else if (index < 50) {
        dot.target = getPositionInRing(
          26 + index - (frame % 5000) * 0.005,
          24,
          CANVAS_SIZE * 0.39,
          0.45
        )
        dot.targetOpacity = 1 - (CANVAS_SIZE * 0.5 - dot.target.y) / (CANVAS_SIZE * 0.39 * 0.45)
        dot.target.y += 0
      } else if (index < 66) {
        dot.target = getPositionInRing(
          50 + index - (frame % 5000) * 0.005,
          16,
          CANVAS_SIZE * 0.34,
          0.45
        )
        dot.targetOpacity = 1 - (CANVAS_SIZE * 0.5 - dot.target.y) / (CANVAS_SIZE * 0.34 * 0.45)
        dot.target.y += 80
      } else if (index < 78) {
        dot.target = getPositionInRing(index - (frame % 5000) * 0.005, 10, CANVAS_SIZE * 0.2, 0.45)
        dot.targetOpacity = 1 - (CANVAS_SIZE * 0.5 - dot.target.y) / (CANVAS_SIZE * 0.2 * 0.45)
        dot.target.y += 150
      } else if (index < 79) {
        dot.target = { x: CANVAS_SIZE * 0.5, y: CANVAS_SIZE * 0.5 - 160 }
        dot.targetOpacity = 0.8
      } else if (index < 80) {
        dot.target = { x: CANVAS_SIZE * 0.5, y: CANVAS_SIZE * 0.5 + 160 }
        dot.targetOpacity = 0.8
      }
    } else {
      dot.targetSize = 0
      dot.targetOpacity = 0
    }
  }

  const moveDot = index => {
    const dot = dots[index]
    const lerpFactor = 16
    const opacityLerpFactor = 4
    const x = (dot.pos.x * lerpFactor + dot.target.x) / (lerpFactor + 1)
    const y = (dot.pos.y * lerpFactor + dot.target.y) / (lerpFactor + 1)
    const size = (dot.size * lerpFactor + dot.targetSize) / (lerpFactor + 1)
    const opacity = (dot.opacity * opacityLerpFactor + dot.targetOpacity) / (opacityLerpFactor + 1)
    dot.pos = { x, y }
    dot.size = size
    dot.opacity = opacity
  }

  const drawDot = dot => {
    ctx.beginPath()
    ctx.arc(dot.pos.x, dot.pos.y, dot.size, 0, 2 * Math.PI)
    ctx.fillStyle = `rgba(${dot.colored ? "16,248,228," : "255,255,255,"}${dot.opacity})`
    ctx.fill()
  }

  const draw = () => {
    clearTimeout(drawTimeout)
    if (ctx) {
      // Clear the canvas
      ctx.clearRect(0, 0, CANVAS_SIZE, CANVAS_SIZE)
      const RNG = new SeededRandom(83423)
      dots.forEach((_, index) => updateDot(index, RNG))
      dots.forEach((_, index) => moveDot(index))
      if (format === 1) {
        ctx.strokeStyle = "rgba(255,255,255,0.5)"
        ctx.beginPath()
        ctx.moveTo(dots[1].pos.x, dots[1].pos.y)
        ctx.lineTo(dots[10].pos.x, dots[10].pos.y)
        ctx.stroke()
        ctx.strokeStyle = "transparent"
      }
      // Reverse loop so the leftover dots are on the bottom
      for (let i = dots.length - 1; i >= 0; i--) {
        drawDot(dots[i])
      }
      // Draw a new frame in a 60th of a second
      frame += 1
      drawTimeout = setTimeout(() => draw(), 1000 / 60)
    }
  }

  const setupCanvas = () => {
    dpr = Math.ceil(window.devicePixelRatio) + 1 || 1
    canvasRef.width = CANVAS_SIZE * dpr
    canvasRef.height = CANVAS_SIZE * dpr
    ctx = canvasRef.getContext("2d")
    ctx.scale(dpr, dpr)
  }

  React.useEffect(() => {
    if (isSetup) {
      clearTimeout(drawTimeout)
      setupCanvas()
      draw()
    }
    return () => {}
  }, [format])

  React.useEffect(() => {
    setupCanvas()
    setupDots()
    setIsSetup(true)
    draw()
    return () => {}
  }, [])

  return (
    <div className={className}>
      <canvas
        ref={r => {
          canvasRef = r
        }}
        width={CANVAS_SIZE}
        height={CANVAS_SIZE}
      />
    </div>
  )
}

export default PillarGraphic
